import { createFileRoute, Outlet } from "@tanstack/react-router";
import { applyAuthGuard } from "@/routes/-auth-guard";
import DashboardLayout from "@/app/dashboard/layout";

export const Route = createFileRoute("/clients/$clientId/dashboard")({
  beforeLoad: ({ location }) =>
    applyAuthGuard(location.pathname, new URLSearchParams(location.searchStr)),
  component: () => (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  ),
});
